<template>
    <div>
        <h1 
            class="first-header heading-medium"
        >
            <i class="fas fa-chart-line mr-2"></i>
            Market Prices
        </h1>
        <div 
            class="table-container"
            :class="{
                'justify-content-center': productPrices.length < 1,
                'card': homePage,
                'px-3' : $breakpoint.mdAndDown && homePage
            }"
        >
            <div 
                v-if="homePage"
                class="row mx-0"
                :class="$breakpoint.lgAndDown ? 'pt-3 pb-3' : 'py-3'"
            >
                <div 
                    class="col-md-12 col-sm-6 offset-sm-6 col-12 offset-md-0"
                    :class="{'px-0' : $breakpoint.mdAndDown}"
                >
                    <button @click="$store.dispatch('livePrices/editSettlementPrices')" class="btn btn-secondary float-right">
                        {{ settlementPricesButtonText }}
                    </button>
                </div>
            </div>
            <div v-if="productPrices.length < 1"
                class="alert alert-secondary mt-3 text-center">
                <i class="fas fa-info-circle mr-2"></i>Market Prices will not be displayed until Settlement prices have been updated. Click on {{ settlementPricesButtonText }} to update Settlement Prices
            </div>
            <table v-else class="table responsive-table">
                <thead v-if="productPrices.length > 0">
                    <tr>
                        <th>Products</th>
                        <th v-for="(productId, key) in orderedProductIds" :key="key">
                            <b>{{productId | rawfueltype}}</b> 
                        </th>
                    </tr>
                </thead>
                
                <tbody>
                    <tr
                        :class="{'py-2': $breakpoint.smAndDown}"
                        v-for="(row, idx) in rows"
                        :key="idx"
                    >
                        <th :colspan="[productPrices.length < 1 ? '7' : '1']">{{ row.title }}</th>
                        <td v-for="(product, key) in productPrices" :key="key" :label="product.fuel_id | rawfueltype">
                            <span v-if="product[row.field]">{{ product[row.field] | priceformat }}</span>
                            <span v-else>&mdash;</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>


<script>

import {mapState,mapGetters} from 'vuex';
import breakpoint from '@/mixins/index';
import { rulesEnum } from "@/util/enums/rules";

export default {
    mixins: [breakpoint],
    data: function(){
        return {
            mapPrices: '',
            homePage: false
        }
      
    },
    computed:{
        ...mapState('livePrices',['showDailyPriceModal']),
        ...mapGetters('livePrices',['getPrices','getPricesUpdate', 'settlementPricesButtonText']),
        rows(){
            return [
                { title: `Prices (${rulesEnum.eUnitType.UsdPerMetricTonne.display})`, field: "price" },
                { title: 'Settle Base Price (ppl)', field: "totalFixed" },
                { title: 'Market Change (ppl)', field: "marketChange" },
                { title: 'Live Base Price (ppl)', field: "totalLive" }
            ];
        },
        orderedProductIds() {
          const acceptedProductList = ['DieselId', 'BioDieselId', 'BlendedDieselBioId', 'GasoilId', 'BlendedGasoilId', 'KeroseneId']
          const productConfig = this.$store.getters['metadata/productConfig'];
          return acceptedProductList.map(item => productConfig[item]);
        },
        productPrices(){
            let prices = [];

            if(this.getPrices && this.getPrices.length > 0){
                for (const productId of this.orderedProductIds){
                    const product = this.getPrices.find(p => p.fuel_id === productId); // Find the matching product
                    prices.push(product);
                }
            }
            
            return prices;
        }
    },
    created(){
        if(this.$route.name === 'manageOffers') {
            this.homePage = false;
        } else {
            this.homePage = true;
        }
    
    },
    
}
</script>

<style lang="scss" scoped>
th, td:not(.no-results) {
    @include media-breakpoint-up(lg) {
        width: calc(100%/7);
    }
}

th:not(:first-of-type), td {
    text-align: center;
}

#select-currency {
    max-width: 200px;
    display: inline-block;
    height: 1.5rem;
    margin: 0.5rem;
}

</style>
